"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TYPES = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _userflow = require("../../utils/userflow");

var _excluded = ["value", "type", "isMobile"];
var TYPES = {
  BACKGROUND: 'background',
  BORDER: 'border'
};
exports.TYPES = TYPES;

var SearcherFlexBadge = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var value = _ref.value,
      type = _ref.type,
      isMobile = _ref.isMobile,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledSearcherFlexBadge, (0, _extends2["default"])({
    type: type,
    isMobile: isMobile
  }, props), "\xB1".concat((0, _userflow.numberRestrictor)(value, 0, Infinity)));
});

SearcherFlexBadge.propTypes = {
  className: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(Object.values(TYPES)),
  value: _propTypes["default"].number,
  isMobile: _propTypes["default"].bool
};
SearcherFlexBadge.defaultProps = {
  className: '',
  type: TYPES.BACKGROUND,
  value: 2,
  isMobile: false
};

var StyledSearcherFlexBadge = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFlexBadge__StyledSearcherFlexBadge",
  componentId: "sc-mfe0k5-0"
})(["border-radius:4px;color:#4D4D4D;font-weight:normal;font-size:9px;width:20px;height:14px;text-align:center;vertical-align:middle;display:inline-block;", ";", ";", ";"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && "\n    font-size: 12px;\n    width: 22px;\n    height: 18px;\n  ";
}, function (_ref3) {
  var type = _ref3.type;
  return type === TYPES.BACKGROUND && "\n    background-color: #f5f3f2;\n  ";
}, function (_ref4) {
  var type = _ref4.type;
  return type === TYPES.BORDER && "\n    border: 1px solid #4D4D4D;\n  ";
});

var _default = SearcherFlexBadge;
exports["default"] = _default;